<template>
  <div>
    <embed-api-table
      title="Keyword URL Positions"
      module="Url-Positions"
      default-sort="searchDate ASC"
      v-bind:columns="positionColumns"
      v-bind:filter="positionFilter">
    </embed-api-table>
    
    
  </div>
</template>

<script>
  import EmbedApiTable from "./EmbedApiTable.vue";
  import WebLLCRESTApi from "../api/api";
  
  export default {
    props: {
      clientId: String
    },
    
    data() {
      return {
        positionColumns: [
          { key: "bulkdelete", "text": "", type: "BulkDelete", sort: false },
          { key: "keyword", "text": "Keyword", type: "String", sort: true },
          { key: "url", "text": "URL", type: "String", sort: true },
          { key: "searchDate", "text": "Search Date", type: "Date", sort: true },
          { key: "searchType", "text": "Search Type", type: "String", sort: true },
          { key: "position", "text": "Position", type: "String", sort: true },
          { key: "delete", "text": "Delete", type: "Delete", sort: false },
        ],
        
        positionFilter: { clientId: this.clientId }
      };
    },
    
    methods: {
      
    },

    components: {
      EmbedApiTable
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SearchPositionTable.vue